<template>
  <div class="choiceType">
    <!--创建新单-->
    <el-dialog
      :title="$t('salePurchase.addOrder')"
      :visible.sync="dialogAdd"
      :close-on-click-modal="false"
      width="350px"
    >
      <el-radio-group v-model="radio" class="tradeType">
        <el-radio v-for="(item, index) in options" :key="index" :label="item.value">{{
          item.label
        }}</el-radio>
      </el-radio-group>

      <div slot="footer" class="dialog-footer">
        <el-button type="primary" :loading="loading" @click="addSure()">{{
          $t('dialog.confirm')
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  // import BASE_API from '@/api/dataBase.js';

  export default {
    name: 'choiceType',
    data() {
      return {
        dialogAdd: false,
        loading: false,
        radio: '',
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo,
      }),
      options() {
        return this.$baseRequest.getDictListByType('transferType');
      },
    },
    methods: {
      openDialog(flag) {
        this.dialogAdd = flag;
        this.radio = '';
      },
      addSure() {
        if (this.radio == '') {
          this.$message({
            showClose: true,
            message: '请选择转款单类型',
            type: 'error',
          });
          return;
        }
        this.dialogAdd = false;
        let path = {
          path: '/transfer/transferAdd',
          name: 'transferAdd',
          meta: {
            keepAlive: true,
            title: '转款单创建',
          },
          query: { transferType: this.radio, type: 'add' },
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
    },
  };
</script>
<style lang="scss" scoped>
  .tradeType {
    display: block;
    // width: 100%;
    margin-left: 30%;
    .el-radio {
      height: 30px;
      margin-right: 0px;
      display: block;
    }
  }
</style>
